<template>
  <core-price-display :base-price="basePrice" :discounted-price="price" free-text="" />
</template>

<script setup>
  const props = defineProps({
    basePrice: {
      type: Number,
      required: true
    },
    productId: [String, Number],
    promotion: Object
  });

  const finalPromotion = computed(() => props.promotion || usePricingStore().promotions?.find(p => p.id === props.productId)?.primary_promotion);
  const price = computed(() => {
    // BOGO discounts apply to another item, not this product's starting price.
    if (finalPromotion.value?.bogo === true) return null;

    const percentOff = finalPromotion.value?.percent_off || 0;
    return props.basePrice - Math.floor(props.basePrice * (percentOff / 100));
  });
</script>
